//analytics
import { IMPRESSION_ACTIONS, CLICK_ACTIONS, SCREEN_NAME } from "@payment-client/analytics/constants";
import { AnalyticsContextValue } from "@swiggy-private/analytics";

export const clickPayAfterOrder = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    slider?: boolean,
    Width?: number,
): void => {
    clickEvent({
        category: slider != null ? SCREEN_NAME.CHECKOUT : SCREEN_NAME.PAYMENT,
        action: CLICK_ACTIONS.CLICK_PAY_AFTER_ORDER,
        context: slider != null ? JSON.stringify({ slider, Width }) : undefined,
    });
};

export const impressionPayAfterOrder = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    slider?: boolean,
): void => {
    impressionEvent({
        category: slider != null ? SCREEN_NAME.CHECKOUT : SCREEN_NAME.PAYMENT,
        context: slider != null ? JSON.stringify({ slider }) : undefined,
        action: IMPRESSION_ACTIONS.IMPRESSION_PAY_AFTER_ORDER,
    });
};
